$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-nav").toggleClass("active");
        $("body").toggleClass("freeze");
    });



    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-nav").removeClass("active");
            $(".js-navbutton").removeClass("active");
            $("body").removeClass("freeze");
            $(".js-header-logo-Link").removeClass("navOpen");
            $(".js-imagecard-parent").removeClass("active");
            $(".js-tooltip").removeClass("active");
        }
    });



    $(".js-navmobile-parent .js-navmobile-icon").click(function (e) {
        $(this).toggleClass("active");
        const nav = $(this).parents(".js-navmobile-parent").find(".js-navmobile-subnav")
        const isExpanded = nav.attr("aria-expanded") === "true";
        nav.attr("aria-expanded", !isExpanded);
    })

    var $mobileSubNav = $(".js-navmobile-subnav");
    if ($mobileSubNav.has("li.active").length > 0) {
        $mobileSubNav.attr("aria-expanded", true);
    }

    $(".js-nav ul li a").click(function () {
        $(".js-nav").removeClass("active");
    })
    is_fine = matchMedia('(pointer:fine)').matches
    is_coarse = matchMedia('(pointer:coarse)').matches

    $('.js-nav-parent').each(function () {
        var $navParent = $(this);
        var $link = $navParent.find('a').first();
        var $subNavWrapper = $navParent.find(".js-sub-nav")

        $link.on('click', function (event) {
            if (is_coarse) {

                if ($subNavWrapper.hasClass("open")) {
                    // If submenu is already open, follow the link
                    window.location.href = $link.attr('href');
                } else {
                    // Otherwise, toggle the submenu
                    event.preventDefault(); // Prevent following the link
                    $subNavWrapper.toggleClass("open");
                    $navParent.siblings(".js-nav-parent").find('.header__subNavWrapper').removeClass("open");
                }
            }
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    var $heroSlider = $(".js-heroslider");

    if ($heroSlider.length) {

        function getVideoSelector() {
            return window.innerWidth > 1000 ? '.js-heroslider-video-desktop' : '.js-heroslider-video-mobile';
        }

        function initSlider($wrapper) {
            var duration = $wrapper.data("duration");
            var durationInMilliseconds = duration * 1000;
            var $track = $wrapper.find(".js-heroslider-track");

            // Destroy existing instance if present
            if ($track.hasClass('slick-initialized')) {
                $track.slick('unslick');
            }

            $track.slick({
                infinite: true,
                autoplay: false,
                autoplaySpeed: durationInMilliseconds,
                fade: true,
                speed: 0,
                adaptiveHeight: true,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                appendDots: false,
                arrows: false,
            });

            // If only one slide, loop the video instead of listening for 'ended'
            var slick = $track.slick('getSlick');
            if (slick.slideCount === 1) {
                var videoSelector = getVideoSelector();
                var singleVideo = $track.find('.js-heroslider-video-wrapper ' + videoSelector).first().get(0);
                if (singleVideo) {
                    singleVideo.setAttribute('loop', '');
                }
            }

            $wrapper.off('beforeChange').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var videoSelector = getVideoSelector();

                // Pause and reset current video
                var currentVideo = $(slick.$slides[currentSlide])
                    .find('.js-heroslider-video-wrapper ' + videoSelector).get(0);
                if (currentVideo) {
                    currentVideo.load();
                }

                // Play next video
                var nextSlideElement = $(slick.$slides[nextSlide]);
                var nextVideo = nextSlideElement.find('.js-heroslider-video-wrapper ' + videoSelector).get(0);

                if (nextVideo) {
                    // Clone to remove stacked event listeners
                    var clone = nextVideo.cloneNode(true);
                    nextVideo.parentNode.replaceChild(clone, nextVideo);
                    nextVideo = clone;

                    nextVideo.play();

                    var $slider = $wrapper.find('.js-heroslider-track');
                    nextVideo.addEventListener('ended', function () {
                        $slider.slick('slickNext');
                    });
                } else {
                    var $slider = $wrapper.find('.js-heroslider-track');
                    setTimeout(function () {
                        $slider.slick('slickNext');
                    }, durationInMilliseconds);
                }

                $wrapper.find(".js-heroslider-nav button").removeClass("active")
                    .eq(nextSlide).addClass("active");
            });

            // Start first video in this slider
            var videoSelector = getVideoSelector();
            var $videoWrapper = $wrapper.find(".js-heroslider-video-wrapper");
            if ($videoWrapper.length) {
                var firstVideo = $videoWrapper.find(videoSelector).first().get(0);
                if (firstVideo) {
                    firstVideo.play();
                    firstVideo.addEventListener('ended', function () {
                        $wrapper.find('.js-heroslider-track').slick('slickNext');
                    });
                }
            }
        }

        // Init all sliders
        $heroSlider.each(function () {
            initSlider($(this));
        });

        // Nav buttons
        $(".js-heroslider-nav button").click(function () {
            $(this).addClass("active").siblings().removeClass("active");
            var index = $(this).index();
            $(this).parents(".js-heroslider").find('.js-heroslider-track').slick('slickGoTo', index);
        });

        // Reinitialize on resize (debounced)
        var resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                $heroSlider.each(function () {
                    initSlider($(this));
                });
            }, 250);
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * infoSlider
    // *
    // *
    var $infoSlider = $(".js-infoslider");

    if ($infoSlider.length) {
        $infoSlider.each(function () {
            var duration = $(this).data("duration");
            $(this).css('--animation-duration', duration + 's');
            var durationInMillseconds = duration * 1000;
            $(this).find(".js-infoslider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: true,
                adaptiveHeight: true,
                autoplaySpeed: durationInMillseconds,
                speed: 200,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-infoslider-dots"),
                prevArrow: $(this).find(".js-infoslider-prev"),
                nextArrow: $(this).find(".js-infoslider-next"),
                customPaging: function (slider, i) {
                    return '<button type="button" role="button" class="infoSlider__dotsButton"></button>';
                }
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teamSlider
    // *
    // *
    var $teamSlider = $(".js-teamslider");

    if ($teamSlider.length) {
        $teamSlider.each(function () {
            var duration = $(this).data("duration");
            var autopplay = $(this).data("autoplay") === 'noAutoplay' ? false : true;
            $(this).css('--animation-duration', duration + 's');
            var durationInMillseconds = duration * 1000;
            $(this).find(".js-teamslider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: autopplay,
                adaptiveHeight: true,
                autoplaySpeed: durationInMillseconds,
                speed: 200,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-teamslider-dots"),
                prevArrow: false,
                nextArrow: false,
                customPaging: function (slider, i) {
                    return '<button type="button" role="button" class="teamSlider__dotsButton"></button>';
                }

            })
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * serviceSlider
    // *
    // *
    var $serviceSlider = $(".js-serviceslider");

    if ($serviceSlider.length) {
        $serviceSlider.each(function () {
            var duration = $(this).data("duration");
            $(this).css('--animation-duration', duration + 's');
            var durationInMillseconds = duration * 1000;
            $(this).find(".js-serviceslider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: true,
                adaptiveHeight: false,
                autoplaySpeed: durationInMillseconds,
                speed: 200,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-serviceslider-dots"),
                prevArrow: false,
                nextArrow: false,
                customPaging: function (slider, i) {
                    return '<button type="button" role="button" class="serviceSlider__dotsButton"></button>';
                }
            });
        });
    }





    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * tooltip
    // *
    // *
    $(".js-tooltip-button").click(function (e) {
        e.stopPropagation(); // verhindert, dass der Klick das Dokument-Event auslöst
        $(this).parents(".js-tooltip").toggleClass("active");
    });

    // Klick irgendwo anders auf der Seite
    $(document).click(function (e) {
        // Wenn der Klick nicht innerhalb eines .js-tooltip war
        if (!$(e.target).closest(".js-tooltip").length) {
            $(".js-tooltip.active").removeClass("active");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * image card (name)
    // *
    // *
    $('.js-imagecard-name').on('click', function (e) {
        var $parent = $(this).parents(".js-imagecard-parent")
        $parent.toggleClass("active");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * doube-click (link)
    // *
    // *
    $('.js-imagecard-link').on('click', function (e) {
        var $parent = $(this).parents(".js-imagecard-parent")
        if (!$parent.hasClass('active')) {
            e.preventDefault();
            $parent.addClass('active');
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter
    // *
    // *
    // Öffnen und Schließen der Dropdowns
    $('.js-dropdown-button').on('click', function (e) {
        e.stopPropagation();
        $(this).closest('.js-dropdown').toggleClass('active').siblings().removeClass('active');
    });

    // Klick innerhalb des Menüs verhindert das Schließen
    $('.js-dropdown-menu').on('click', function (e) {
        e.stopPropagation();
    });

    // Klick auf eine Checkbox
    $('.js-dropdown-checkbox').on('click', function () {
        $('.js-dropdown').removeClass('active');
    });

    // Schließen der Dropdowns bei Klick außerhalb
    $(document).on('click', function () {
        $('.js-dropdown').removeClass('active');
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filterResources
    // *
    // *
    var $blogContent = $(".js-blog-content");
    var $blogFilter = $(".js-blog-filter");
    var $spinner = $('.js-spinner');

    // Initialize active filters on page load
    function initializeActiveFilters() {
        var urlObj = new URL(window.location.href);
        var searchParams = new URLSearchParams(urlObj.search);

        // Loop through all filter elements
        $blogFilter.each(function () {
            var $filter = $(this);
            var href = $filter.attr("href");
            var hrefObj = new URL(href, window.location.origin);
            var filterSearchParams = new URLSearchParams(hrefObj.search);

            // Check if this filter's parameters are in the current URL
            var isActive = true;
            filterSearchParams.forEach(function (value, key) {
                var urlValues = searchParams.getAll(key);
                if (!urlValues.includes(value)) {
                    isActive = false;
                }
            });

            // Set active class if filter matches current URL
            if (isActive && filterSearchParams.toString()) {
                $filter.addClass("active");
            }
        });
    }

    // Call on page load
    $(document).ready(function () {
        initializeActiveFilters();
    });

    // click filter
    $blogFilter.click(function (e) {
        e.preventDefault();

        // Show the spinner overlay
        $spinner.addClass("active");

        // Get the current URL and its query parameters
        var currentUrl = window.location.href;
        var urlObj = new URL(currentUrl);
        var searchParams = new URLSearchParams(urlObj.search);

        // Get the filter name and value from the clicked element
        var href = $(this).attr("href");
        var hrefObj = new URL(href, window.location.origin);
        var newSearchParams = new URLSearchParams(hrefObj.search);

        // Check if this filter is already active
        var isActive = $(this).hasClass("active");
        var filterKey = Array.from(newSearchParams.keys())[0];
        var filterValue = newSearchParams.get(filterKey);

        if (isActive) {
            // Remove the active class
            $(this).removeClass("active");

            // Remove this specific parameter value from the URL
            var existingValues = searchParams.getAll(filterKey);
            searchParams.delete(filterKey);

            // Re-add all values except the one we're removing
            existingValues.forEach(function (value) {
                if (value !== filterValue) {
                    searchParams.append(filterKey, value);
                }
            });
        } else {
            // Add the filter
            newSearchParams.forEach(function (value, key) {
                var existingValues = searchParams.getAll(key);
                if (!existingValues.includes(value)) {
                    searchParams.append(key, value);
                }
            });

            // Update the active state for the clicked filter
            $(this).addClass("active");
        }

        // Update the URL with the merged query parameters
        urlObj.search = searchParams.toString();
        var newUrl = urlObj.toString();

        // Fetch the new content
        $.get(newUrl)
            .done(function (data) {
                $blogContent.html($(data).find(".js-blog-content").html());
                // Update the browser's URL without reloading
                window.history.pushState({}, "", newUrl);
            })
            .always(function () {
                // Hide the spinner overlay when the request is complete
                $spinner.removeClass("active");
            });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * aside
    // *
    // *
    const $asideItems = $('.js-aside-item');

    // Check if device supports touch/coarse pointer
    const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;

    if (isCoarsePointer) {
        // Mobile click handler
        $asideItems.on('click', function (e) {
            const $this = $(this);
            const $link = $this.find('a');
            const href = $link.attr('href');

            // If already active, follow the link
            if ($this.hasClass('active')) {
                window.location.href = href;
                return;
            }

            // First click: prevent default, show label, mark as active
            e.preventDefault();
            e.stopPropagation();

            // Deactivate other items
            $asideItems.not($this).removeClass('active');

            // Activate this item
            $this.addClass('active');
        });

        // Click outside to deactivate
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.js-aside').length) {
                $asideItems.removeClass('active');
            }
        });
    }

    // Popup: show once per visitor based on cookie-days data attribute (0 = always show)
    (function () {
        var dialog = document.querySelector('.js-dialog');
        if (!dialog) return;
        var cookieHours = parseInt(dialog.dataset.cookieHours, 10) || 0;
        if (cookieHours === 0) {
            document.cookie = 'popup_seen=1; max-age=0; path=/';
        }
        if (document.cookie.match(/popup_seen=1/)) return;

        function closePopup() {
            dialog.close();
            if (cookieHours > 0) {
                document.cookie = 'popup_seen=1; max-age=' + (60 * 60 * cookieHours) + '; path=/';
            } else {
                // delete cookie so popup shows again on next reload
                document.cookie = 'popup_seen=1; max-age=0; path=/';
            }
        }

        setTimeout(function () {
            dialog.showModal();
        }, 1000);

        $(document).on('click', '.js-close-dialog', function () {
            closePopup();
        });

        // close on backdrop click
        dialog.addEventListener('click', function (e) {
            if (e.target === dialog) closePopup();
        });

        // focus trap
        dialog.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            var focusable = dialog.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === first) { e.preventDefault(); last.focus(); }
            } else {
                if (document.activeElement === last) { e.preventDefault(); first.focus(); }
            }
        });
    }());
});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
        $(".js-badge").addClass("sticky")
        $(".js-aside").addClass("show");
    } else {
        $(".js-header").removeClass("sticky");
        $(".js-badge").removeClass("sticky");
        $(".js-aside").removeClass("show");
    }
});

$(window).on("resize", function () {
    if (window.innerWidth > 1300 && $(".js-nav.active").length) {
        $("body").removeClass("freeze");
        $(".js-nav").removeClass("active");
        $(".js-navbutton").removeClass("active");
    }
});


